export default __webpack_public_path__ + "static/media/admin-home-screenshot.5069aa4e.png";